import React from 'react';
import PropTypes from 'prop-types';
import { View } from '@dbk/ui-react-utils';

import './styles.css';

const ArrowDown = (props) => {
  const {
    style,
    className
  } = props;

  return (
    <View className={`arrow-down__container ${className}`} style={style}>
      <View className={'arrow-down__body'} />
    </View>
  );
}

ArrowDown.propTypes = {
  style: PropTypes.oneOf([
    PropTypes.object,
    PropTypes.array
  ]),
  className: PropTypes.string
}

ArrowDown.defaultProps = {
  style: {},
  className: ''
}

export default ArrowDown;
